import { Dispatch, SetStateAction, useState } from "react";
import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { FormCreateScheduling } from "./form-create-scheduling";
import { FormEditScheduling } from "./form-edit-scheduling";
import { Scheduling } from "@/types";
import { useNavigate } from "react-router-dom";

type FormSchedulingProps = {
  children?: React.ReactNode;
  scheduling?: Scheduling;
  isEdit?: boolean;
  setIsEdit?: Dispatch<SetStateAction<boolean>>;
  defaultDate?: string;
  defaultStartTime?: string;
  defaultEndTime?: string;
  isInCalendary?: boolean;
  patientId?: string;
};

export function FormScheduling({
  children,
  scheduling,
  isEdit = false,
  defaultDate,
  setIsEdit,
  defaultEndTime,
  defaultStartTime,
  patientId
}: FormSchedulingProps) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  function handleClose() {
    setOpen(false);
    setIsEdit?.(false);
  }

  function removeQueryParams() {
    queryParams.delete("patient");
    queryParams.delete("collaborator");
    queryParams.delete("procedure");
    queryParams.delete("budget");
    queryParams.delete("value");
    queryParams.delete("openForm");
    navigate(`${location.pathname}?${queryParams.toString()}`);
  }
  const Container = scheduling ? Drawer : Dialog;
  const Trigger = scheduling ? DrawerTrigger : DialogTrigger;
  const Content = scheduling ? DrawerContent : DialogContent;

  return (
    <Container
      open={setIsEdit ? isEdit : open}
      onOpenChange={() => {
        if (typeof setIsEdit !== "undefined") {
          setIsEdit(!isEdit);
        }

        if (typeof setOpen !== "undefined") {
          setOpen(!open);
        }
        if (queryParams.get("openForm")) {
          removeQueryParams();
        }
      }}
    >
      <Trigger asChild>{children}</Trigger>
      <Content className={scheduling ? "h-[94vh]" : "flex max-h-[calc(100dvh-2rem)] w-[calc(100%-2rem)] max-w-4xl flex-col gap-0 overflow-hidden rounded-2xl border-app-border bg-app-surface p-0 shadow-premium-md sm:rounded-2xl"}>
        {scheduling ? (
          <FormEditScheduling
            scheduling={scheduling}
            handleClose={handleClose}
            patientId={patientId}
          />
        ) : (
          <FormCreateScheduling
            handleClose={handleClose}
            defaultDate={defaultDate}
            defaultStartTime={defaultStartTime}
            defaultEndTime={defaultEndTime}
            patientId={patientId}
          />
        )}
      </Content>
    </Container>
  );
}
